import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=f88fcd32&scoped=true&"
import script from "./checkout.vue?vue&type=script&lang=ts&"
export * from "./checkout.vue?vue&type=script&lang=ts&"
import style0 from "./checkout.vue?vue&type=style&index=0&id=f88fcd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88fcd32",
  null
  
)

export default component.exports